import type { KeyboardEvent } from "react";
import { useId } from "react";
import { useTranslation } from "react-i18next";
import { Field } from "@/widgets/classic-form/form";
import { useTrackSearchFormInteraction } from "@/shared/lib/ube";
import { RecordSubject } from "../../form/types";
import styles from "./RotatedRecords.module.scss";

export const RotatedRecords = () => {
    const { t } = useTranslation();
    const id = useId();
    const track = useTrackSearchFormInteraction();

    const handleKeyDown = (
        e: KeyboardEvent<HTMLInputElement>,
        value: RecordSubject,
        callback: (v: RecordSubject) => void,
    ) => {
        if (e.key === "Enter" || e.key === " ") {
            const next = value === RecordSubject.Primary ? RecordSubject.All : RecordSubject.Primary;
            track({ action: next === RecordSubject.Primary ? "check" : "uncheck", objectName: "rotated_records" });
            callback(next);
            e.preventDefault();
        }
    };

    return (
        <Field name="recordSubject">
            {({ value, onChange }) => (
                <div className={styles.primaryRecordsOnly}>
                    <input
                        id={id}
                        type="checkbox"
                        className="checkbox"
                        checked={value === "primary"}
                        onChange={() => {
                            const next = value === RecordSubject.Primary ? RecordSubject.All : RecordSubject.Primary;
                            track({
                                action: next === RecordSubject.Primary ? "check" : "uncheck",
                                objectName: "rotated_records",
                            });
                            onChange(next);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, value, onChange)}
                        title={t("primaryRecordsOnly")}
                    />
                    <label htmlFor={id}>{t("primaryRecordsOnly")}</label>
                </div>
            )}
        </Field>
    );
};
